import { axiosIns, axiosInsWheel } from '../../helpers/axios/index';

export const state = {
  logs: [],
};

export const getters = {
  getLogs() {
    return state.logs;
  },
};

export const mutations = {
  setLogs(state, payload) {
    state.logs = payload;
  },
};

export const actions = {
  async fetchLogs({ commit }, { params, type }) {
    try {
      const data = await fetchLogsByType({ params, type });

      commit('setLogs', data);
    } catch (error) {
      console.log('ERROR FETCH LOGS', error);
      commit('setLogs', []);
    }
  },
  /**
   * @typedef {Object} Log
   * @property {Object} request - Objeto request
   * @property {Object} response - Objeto response
   * @property {string} error - Error 
   * @property {boolean} success
   * @property {string} ip 
   * @property {string} type 
   */

  /**
   * @param { Object } state.commit - Para ejectuar los commits del store
   * @param { Log } log - Objeto para enviar a la api y guardar el log
   */
  async create(_, log) {
    try {
      await axiosIns.post('logs', log);

      return true;
    } catch (error) {
      console.log('ERROR CREATE LOG', error);
      return false;
    }
  },
  saveLogInLocalStorage(_, log) {
    const logs = JSON.parse(localStorage.getItem('logs')) || [];

    logs.push({
      ...log,
      created_at: new Date().toISOString(),
    });

    localStorage.setItem('logs', JSON.stringify(logs));
  },
  getLogsFromLocalStorage({ commit }, { page, limit }) {
    const logsLS = localStorage.getItem('logs')

    const data = JSON.parse(logsLS || '[]') || [];

    const logs = data.slice((page - 1) * limit, page * limit);
    commit('setLogs', logs);
  }
};

const fetchLogsByType = async ({ params, type }) => {
  let data;

  try {
    switch (type) {
      case LOGS.roulette:
        {
          const { data: dataRoulette } = await axiosIns.get('logs/all', {
            params,
          });

          if (!dataRoulette.ok) {
            data = [];
          } else {
            data = dataRoulette.data;
          }
        }
        break;
      case LOGS.boilerplate:
        {
          const { data: dataBoilerPlate, status } = await axiosInsWheel.get(
            'log',
            {
              params,
            }
          );

          if (status > 201) {
            data = [];
          } else {
            const { logs } = dataBoilerPlate;

            data = logs;
          }
        }
        break;

      default:
        data = [];
        break;
    }
  } catch (error) {
    console.log('ERROR FETCH LOGS BY TYPE', error);
    data = [];
  }

  return data;
};

export const LOGS = {
  roulette: 'LOGS RULETA',
  boilerplate: 'LOGS OTROS JUEGOS',
};

export const errorTypes = {
  credit: 'credit',
  debit: 'debit',
  rollback: 'rollback',
  round: 'round',
};
